import angular from "angular";
import uiRouter from "angular-ui-router";
import "ngstorage";
import auth from "../../services/auth.js";
import security from "../../services/security.js";
import events from "../../services/events.js";
import env from "../../services/env.js";

class EventdialogController {
  constructor($http, $localStorage, $state, AuthService, $rootScope, $scope, SecurityService, EventsService, EnvService, $timeout, TrackingService) {
    this.name = "eventdialog";
    this.$http = $http;
    this.$localStorage = $localStorage;
    this.$state = $state;
    this.$auth = AuthService;
    this.$rootScope = $rootScope;
    this.$security = SecurityService;
    this.$events = EventsService;
    this.$scope = $scope;
    this.$env = EnvService;
    this.$timeout = $timeout;
    this.$tracking = TrackingService;
    this.currentUser = this.$auth.getUserData();
    this.event = {};
    this.openingsList = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30];
    this.openingsListActions = ["Add", "Remove"];
    this.actions = "Add";
    this.multiopenings = null;
    this.openings = 1;
    this.remain_loading_count = 0;
    this.publish_status = null;
    var _this = this;

    _this.SetEventToEventDialogListener = _this.$rootScope.$on("SetEventToEventDialog", function ($event, params) {
      console.log("SetEventToEventDialogListener");
      console.dir(params);
      _this.event = params.event;
      _this.currentOpeningsAmount = params.event.numberOfOpenings;
    });

    _this.SetPublishTypeListener = _this.$rootScope.$on("SetPublishType", function ($event, params) {
      _this.publish_status = params.status;
      _this.publish_message = params.message;
    });

    _this.$scope.$on("$destroy", _this.SetPublishTypeListener);
    _this.$scope.$on("$destroy", _this.SetEventToEventDialogListener);
  }

  openingsUpdate() {
    var _this = this;

    _this.$timeout(function () {
      if (_this.openings > 1) {
        _this.multiopenings = "s";
      } else {
        _this.multiopenings = null;
      }
    });
  }

  keepEvent() {
    var _this = this;
    _this.$timeout(function () {
      jQuery("#modal-del-event").modal("toggle");
    });
  }

  deleteEvent() {
    var _this = this;

    var deleteEventData = {
      method: "DELETE",
      url: _this.$env.getAPIEndPoint() + "jbl/v1/events/" + _this.event.id + "?format=json",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _this.currentUser.access_token,
      },
      data: {},
    };

    _this.$timeout(function () {
      jQuery("#modal-del-event").modal("toggle");
      _this.remain_loading_count++;
    });

    _this.$http(deleteEventData).then(
      function (response) {
        _this.remain_loading_count--;

        _this.$tracking.reportJobCancellation(_this.event, _this.currentUser);
        _this.$timeout(function () {
          _this.$rootScope.$emit("SuccessToDeleteEvent", {
            event: _this.event.id,
          });
          _this.$auth.reloadCurrentUser();
        }, 100);
      },
      function (response) {
        _this.remain_loading_count--;
        console.log(response.data);
      }
    );
  }

  addOpenings() {
    var _this = this;

    if (_this.$security.isUndefinedOrNull(_this.event.subEvents)) {
      _this.remain_loading_count++;
      _this.$events.getEventById(_this.event.id).then(
        function (data) {
          _this.remain_loading_count--;
          if (data.data === "error") {
            return;
          }
          _this.event = data.data;
          _this.jobbleOpeningsUpdate();
        },
        function (data) {}
      );
    } else {
      _this.jobbleOpeningsUpdate();
    }
  }

  jobbleOpeningsUpdate() {
    var _this = this;

    let openings = _this.openings;

    let totalJobOpenings = _this.event.numberOfApprovedApplications + _this.event.numberOfOpenings;

    if (_this.actions === "Remove" && openings > _this.event.numberOfOpenings) {
      alert(
        "Please reduce the number of openings you are trying to remove. You are attempting to remove " + _this.event.numberOfOpenings + " opening(s)."
      );
      return;
    }

    if (_this.actions === "Add") {
      var addOpeningsData = {
        method: "POST",
        url:
          _this.$env.getAPIEndPoint() +
          "jbl/v1/jobbles/" +
          _this.event.subEvents[0].deduppedJobbles[0].id +
          "/add-positions?format=json&conf=web&numberOfPositions=" +
          _this.openings,
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: "Bearer " + _this.currentUser.access_token,
        },
        data: {},
      };
    } else {
      var addOpeningsData = {
        method: "POST",
        url:
          _this.$env.getAPIEndPoint() +
          "jbl/v1/jobbles/" +
          _this.event.subEvents[0].deduppedJobbles[0].id +
          "/rm-positions?format=json&conf=web&numberOfPositions=" +
          _this.openings,
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: "Bearer " + _this.currentUser.access_token,
        },
        data: {},
      };
    }

    _this.remain_loading_count++;

    _this.$http(addOpeningsData).then(
      function (response) {
        _this.remain_loading_count--;

        _this.$timeout(function () {
          $("#modal-add-openings .modal-header button.close").trigger("click");
          _this.actions = "Add";
          _this.multiopenings = null;
          _this.openings = 1;
        });

        if (response.data.status !== "error") {
          _this.event = response.data;
          _this.$rootScope.$emit("SetEventToEventPages", {
            event: _this.event,
            openings: openings,
            action: _this.actions,
          });
        } else if (response.data.status === "error") {
          _this.$timeout(function () {
            alert(response.data.message) + ". Please contact support if having further issues.";
          }, 300);
        }
      },
      function (error) {
        _this.remain_loading_count--;

        _this.$timeout(function () {
          $("#modal-add-openings .modal-header button.close").trigger("click");
          _this.actions = "Add";
          _this.multiopenings = null;
          _this.openings = 1;
        });

        _this.$timeout(function () {
          alert("There was error performing this action. Please refresh and try again.");
        }, 400);
      }
    );
  }

  checkVerificationStatus() {
    var _this = this;

    _this.remain_loading_count--;

    _this.$auth.reloadCurrentUser();

    _this.$timeout(function () {
      _this.currentUser = _this.$auth.getUserData();
    }, 1500);
  }

  publishJob() {
    var _this = this;
    var id = _this.event.subEvents[0].deduppedJobbles[0].id;
    console.log("publish job");
    console.dir(_this.publish_status);
    var status = _this.publish_status;

    if (status === false) {
      status = true;
    } else {
      status = false;
    }
    _this.setLoader();
    _this.$events.markJobblesAsPublished(id, _this.event, status).then(
      function (response) {
        _this.$timeout(function () {
          _this.$rootScope.$emit("SuccessPublishEvent", {
            event: _this.event,
            status: status,
            message: _this.publish_message,
          });
        });
      },
      function (error) {
        console.log("what was the error");
        console.dir(error);
        _this.unSetLoader();
        _this.$timeout(function () {
          alert("error publishing event : " + error.statusText);
        });
      }
    );
  }

  setLoader() {
    var _this = this;
    _this.$timeout(function () {
      $("html").addClass("wait");
    });
  }

  unSetLoader() {
    var _this = this;
    _this.$timeout(function () {
      $("html").removeClass("wait");
    });
  }
}

EventdialogController.$inject = [
  "$http",
  "$localStorage",
  "$state",
  "auth",
  "$rootScope",
  "$scope",
  "security",
  "events",
  "env",
  "$timeout",
  "tracking",
];

export default EventdialogController;



// WEBPACK FOOTER //
// ./client/app/common/eventdialog/eventdialog.controller.js